'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dSystem$002dSite$002dStats from "./presto.types$-Dashboard-System-Site-Stats.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardSystemSiteStats$() {
}
export { $c_Lpresto_types$DashboardSystemSiteStats$ as $c_Lpresto_types$DashboardSystemSiteStats$ };
$p = $c_Lpresto_types$DashboardSystemSiteStats$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardSystemSiteStats$;
/** @constructor */
function $h_Lpresto_types$DashboardSystemSiteStats$() {
}
export { $h_Lpresto_types$DashboardSystemSiteStats$ as $h_Lpresto_types$DashboardSystemSiteStats$ };
$h_Lpresto_types$DashboardSystemSiteStats$.prototype = $p;
$p.l = (function() {
  return "DashboardSystemSiteStats";
});
$p.cFT = (function(x$0) {
  return new $j_presto$002etypes$0024$002dDashboard$002dSystem$002dSite$002dStats.$c_Lpresto_types$DashboardSystemSiteStats(x$0.j(0), (x$0.j(1) | 0));
});
var $d_Lpresto_types$DashboardSystemSiteStats$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardSystemSiteStats$, "presto.types$DashboardSystemSiteStats$", ({
  ZJ: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$DashboardSystemSiteStats$ as $d_Lpresto_types$DashboardSystemSiteStats$ };
var $n_Lpresto_types$DashboardSystemSiteStats$;
function $m_Lpresto_types$DashboardSystemSiteStats$() {
  if ((!$n_Lpresto_types$DashboardSystemSiteStats$)) {
    $n_Lpresto_types$DashboardSystemSiteStats$ = new $c_Lpresto_types$DashboardSystemSiteStats$();
  }
  return $n_Lpresto_types$DashboardSystemSiteStats$;
}
export { $m_Lpresto_types$DashboardSystemSiteStats$ as $m_Lpresto_types$DashboardSystemSiteStats$ };
//# sourceMappingURL=presto.types$-Dashboard-System-Site-Stats$.js.map
